import { Inbox } from "lucide-react";

import { Button } from "@/components/ui/button";

interface EventsEmptyStateProps {
  hasFilters: boolean;
  onClear?: () => void;
}

export function EventsEmptyState({ hasFilters, onClear }: EventsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border bg-card p-12 text-center">
      <Inbox className="mb-3 h-10 w-10 text-muted-foreground" />
      <h3 className="text-base font-semibold">
        {hasFilters ? "Nessun evento trovato" : "Ancora nessun evento"}
      </h3>
      <p className="mt-1 max-w-sm text-sm text-muted-foreground">
        {hasFilters
          ? "Prova a modificare o pulire i filtri per vedere piu' risultati."
          : "Gli eventi elaborati dal parser appariranno qui."}
      </p>
      {hasFilters && onClear ? (
        <Button variant="outline" size="sm" onClick={onClear} className="mt-4">
          Pulisci filtri
        </Button>
      ) : null}
    </div>
  );
}
